import DataTable from 'react-data-table-component';

import { Constant } from '../../../../../Helpers/constant';

const CustomizedTable = ({
  columns = [],
  data = [],
  limit = 10,
  totalCount = 0,
  handleRowsPerPageChange,
  handlePageChange,
  currentPage = 1,
  indexType,
  isTableDisplay = true,
  ...props
}) => {
  let displayedPage; // Declare displayedPage in the outer scope
  let onPageChange; // Declare onPageChange function in the outer scope

  if (indexType === Constant.INDEX_TYPE.ONE_BASED) {
    displayedPage = currentPage;

    // Define the onPageChange function
    onPageChange = page => {
      handlePageChange(page); // Adjust one-based (UI) to zero-based (API)
    };
  } else if (indexType === Constant.INDEX_TYPE.ZERO_BASED) {
    displayedPage = currentPage + 1;

    // Define the onPageChange function
    onPageChange = page => {
      handlePageChange(page - 1); // Adjust one-based (UI) to zero-based (API)
    };
  }
  return (
    <>
      <DataTable
        columns={columns ?? []}
        data={data ?? []}
        highlightOnHover
        pagination
        paginationServer
        onChangePage={onPageChange} // Keeps pagination logic as is
        fixedHeader
        fixedHeaderScrollHeight="400px" // Scrollable table body
        customStyles={{
          headRow: {
            style: {
              borderBottom: '1px solid #ddd',
              fontWeight: '600',
              backgroundColor: '#E9EBEC',
            },
          },
          cells: {
            style: {
              // border: '0.5px solid #ddd',
              borderBottom: '0px solid #ddd',
            },
          },
          rows: {
            style: {
              minHeight: '70px', // Adjust row height
              borderLeft: '1px solid #E6E6E6',
              borderRight: '1px solid #E6E6E6',
              padding: '5px 0 10px',
            },
          },
          pagination: {
            style: {
              borderTop: '1px solid #ddd',
              padding: '10px',
            },
          },
          table: {
            // border: '1px solid #E6E6E6',
            style: isTableDisplay ? {} : { display: 'none' }, // Hide table when isTableDisplay is false
          },
        }}
        paginationRowsPerPageOptions={[10, 15, 20]}
        paginationTotalRows={totalCount}
        paginationPerPage={limit}
        paginationDefaultPage={displayedPage} // Ensures one-based indexing for UI
        onChangeRowsPerPage={handleRowsPerPageChange} // Allows rows-per-page customization
        {...props}
      />
    </>
  );
};

export default CustomizedTable;
